<!--Шаблон для мадального диалогового окна-->
<template>
  <v-dialog
    v-model="open"
    :width="width"
    :fullscreen="$vuetify.display.smAndDown"
    persistent
    scrollable
  >
    <v-card  class="rounded-lg">
      <v-toolbar flat tile rounded="0" width="100%" :color="topColor">
        <slot name="title">
          <span :class="$vuetify.display.mdAndUp ? 'text-h5 pl-6 dark-primary' : 'text-h6 pl-5 dark-primary'">
            {{ title }}
          </span>
        </slot>
        <v-spacer v-if="spacedTitle"></v-spacer>
        <v-btn
          v-show="closed"
          fab
          icon
          small
          class="dark-primary"
          :disabled="loading"
          @click="closeDialog(false)"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="overflow-y-auto scrolled-style py-0 px-4" :style="{height: contentHeight ? contentHeight: undefined}">
        <slot>

        </slot>
      </v-card-text>
      <v-card-actions>
        <slot name="actions">
          <slot name="prepend-actions"></slot>
          <v-spacer v-if="left"></v-spacer>
          <v-btn
            v-if="denyable"
            :color="dennyColor"
            text
            :loading="loading"
            :readonly="loading"
            @click="closeDialog(false)"
          >
            {{ dennyText }}
          </v-btn>
          <v-spacer v-if="between"></v-spacer>
          <v-btn
            v-if="applyable"
            :color="applyColor"
            text
            :loading="loading"
            :readonly="loading"
            @click="closeDialog(true)"
          >
            {{ applyText }}
          </v-btn>
          <v-spacer v-if="right"></v-spacer>
          <slot name="append-actions"></slot>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ScrollCenterDialog",
  props: {
    value: Boolean,
    title: String,
    scrolled: {
      default: true,
      type: Boolean
    },
    closed: {
      default: true,
      type: Boolean
    },
    spacedTitle: {
      default: true,
      type: Boolean,
    },
    between: {
      default: false,
      type: Boolean,
    },
    left: {
      default: true,
      type: Boolean,
    },
    right: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    dennyText: {
      default: 'Отмена',
      type: String,
    },
    dennyColor: {
      default: 'blue darken-1',
      type: String,
    },
    applyable: {
      default: true,
      type: Boolean,
    },
    applyText: {
      default: 'Сохранить',
      type: String,
    },
    applyColor: {
      default: 'blue darken-1',
      type: String,
    },
    topColor: {
      default: 'super-grey',
      type: String
    },
    width: {
      default: '600px',
      type: String,
    },
    contentHeight: {
      default: undefined,
      type: String
    },
    denyable: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      open: false,
    }
  },
  watch: {
    value: {
      /**
       * Сохраняет значение value в open при его изменении
       * @param {boolean} value - Новое значение пропса
       */
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      /**
       * Генерирует событие input с текущим значением open при его изменении
       * @param {boolean} open - Новое состояние открытия
       */
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    }
  },
  methods: {
    closeDialog (emit_apply = false) {
      /**
       * Закрывает диалоговое окно с возможностью подтверждения действия
       * @param {boolean} emit_apply- Флаг, указывающий на подтверждение действия
       */
      if (emit_apply) {
        this.$emit('apply')
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
.scrolled-style::-webkit-scrollbar {
  width: 5px;
}

.scrolled-style::-webkit-scrollbar-track {
}

.scrolled-style::-webkit-scrollbar-thumb {
  background: gray;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
</style>
